import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const migratePrivateDocumentPropertyAndType = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const { language, ...rest } = data;
  const result = { ...rest };

  if (typeof language === 'string') {
    result.languages = [language];
  }
  if ('myTodo' in result) {
    delete result.myTodo;
  }
  if ('myTodoComments' in result) {
    delete result.myTodoComments;
  }

  return result;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  {
    collectionName: CollectionName.PRIVATE_DOCUMENTS,
    migrateItemFunction: migratePrivateDocumentPropertyAndType,
  },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration12: MigrationType = {
  migrate,
  version: 13,
};
